export const accessSecurityCodeForm = [
    {
        cols: [
            {
                formGroup: 'securityCodeForm',
                class: 'col-12 col-lg-8',
                title: 'Insertar Código seguridad',
                titleClass: 'form-title text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-10 col-lg-6 mx-auto',
                item: 'input',
                type: 'text',
                placeholder: 'Código',
                inputClass: 'text-input',
                formControlName: 'code',
                required: true
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-3 col-md-5 col-10 mb-md-0 mb-3',
                item: 'button',
                type: 'regular',
                placeholder: 'Volver a enviar código',
                inputClass: 'form-button btn btn-primary',
                buttonAction: 'resendCode'
            },
            {
                class: 'col-lg-3 col-md-5 col-10',
                item: 'button',
                type: 'regular',
                placeholder: 'Validar',
                inputClass: 'form-button btn btn-primary',
                buttonAction: 'onSubmit'
            }
        ]
    }
]

